import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { a11y, theme } from './theme';
// La charte de la suite d'abord, l'habillage du portail ensuite : les règles
// du portail doivent l'emporter à spécificité égale.
import '@semply/theme/css';
import './styles/theme.css';

// Applique la palette et suit le thème du système. Le script du <head> a déjà
// posé le fond sombre avant la première peinture ; cet appel installe la
// palette complète et l'abonnement aux changements.
theme.start();
a11y.start();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
